import React, { FC, useState } from 'react';
import { NamePath } from 'antd/lib/form/interface';
import dayjs from 'dayjs';
import { Form } from '~/components';
import { DatePicker } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export interface DateInputFromItemProps {
  label?: string;
  name: NamePath;
}

const DateInputRange: FC<DateInputFromItemProps> = (props) => {
  const { name, label } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [t] = useTranslation('agent');

  return (
    <Form.ShouldUpdate names={[name]}>
      {(form) => {
        const values = form.getFieldValue(name);
        const placeholders: [string, string] = [isOpen || !!values ? t('from') : '', t('to')];

        return (
          <StyledFormItem label={isOpen || !!values ? label : `${label} ${t('from')}`} name={name}>
            <RangeDatePicker
              placeholder={placeholders}
              onOpenChange={setIsOpen}
              allowEmpty={[true, true]}
            />
          </StyledFormItem>
        );
      }}
    </Form.ShouldUpdate>
  );
};

const RangeDatePicker = (props: any) => {
  const { value, onChange } = props;
  return <StyledPicker {...props} value={parseValue(value)} onChange={parseOnChange(onChange)} />;
};

const StyledPicker = styled(DatePicker.RangePicker)`
  .ant-picker-active-bar {
    display: none;
  }
  .ant-picker-input:nth-child(1) {
    width: 60%;
  }
  .ant-picker-input:nth-child(3) {
    width: 40%;
  }
`;

const StyledFormItem = styled(Form.Item)`
  .FloatLabel-Label {
    width: calc(50% - 12px);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

const parseValue = (value?: [string, string] | [dayjs.Dayjs, dayjs.Dayjs]): any => {
  return value?.map((d) => {
    if (typeof d === 'string') {
      return dayjs(d);
    }
    return d;
  });
};

const parseOnChange =
  (onChange: ((value: string[] | undefined) => void) | undefined) =>
  (value: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null) => {
    onChange?.(value?.map((d: any) => d?.format('YYYY-MM-DD') ?? null));
  };

export default DateInputRange;
